const WhyTrripToggle = ({ isResolved, onToggle }) => {
  return (
    <div className="relative z-30 mb-10 sm:mb-16 flex items-center justify-center max-w-full px-2">
      <div className="flex bg-[#fdfaf5] p-1.5 sm:p-2 rounded-full relative shadow-inner border border-[#e5d8c8] backdrop-blur-sm">
        {/* Animated Slider Background */}
        <div
          className={`absolute top-1.5 sm:top-2 bottom-1.5 sm:bottom-2 w-[calc(50%-6px)] sm:w-[calc(50%-8px)] rounded-full transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
            isResolved
              ? 'left-[calc(50%+3px)] sm:left-[calc(50%+4px)] bg-[#067978] shadow-sm'
              : 'left-1.5 sm:left-2 bg-[#be4b46] shadow-sm'
          }`}
        />

        {/* Left Toggle (Without Trrip) */}
        <button
          onClick={() => onToggle(false)}
          className={`relative w-28 sm:w-36 md:w-48 py-2.5 sm:py-3.5 text-[10px] sm:text-xs md:text-sm font-bold uppercase tracking-wider sm:tracking-widest transition-colors duration-300 z-10 rounded-full focus:outline-none cursor-pointer ${
            !isResolved ? 'text-white' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Without Trrip
        </button>

        {/* Right Toggle (With Trrip) */}
        <button
          onClick={() => onToggle(true)}
          className={`relative w-28 sm:w-36 md:w-48 py-2.5 sm:py-3.5 text-[10px] sm:text-xs md:text-sm font-bold uppercase tracking-wider sm:tracking-widest transition-colors duration-300 z-10 rounded-full focus:outline-none cursor-pointer ${
            isResolved ? 'text-white' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          With Trrip
        </button>
      </div>
    </div>
  );
};

export default WhyTrripToggle;
